// extracted by mini-css-extract-plugin
export default {"add-recipients-modal":"styles_add-recipients-modal__P-ek9","addRecipientsModal":"styles_add-recipients-modal__P-ek9"};